import React from 'react';
import LocationWithMap from './LocationWithMap';

const apiKey = `AIzaSyA-gF0KHpgsp30yhCZDHHQEJrz3ucGpPUM`;
const styles = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#cacbcb"
            },
            {
                "visibility": "on"
            }
        ]
    }
]

export default ({ prefix, locations, locale }) => {
    const total = locations.length;
    const columnType = Math.ceil(12 / total);

    return (<section className="section is-locations-grid">
        <div className="container">
            <div className="columns is-multiline is-mobile">
                {locations.map((location, index) => (
                    <div key={`${prefix}-location-${index}`} className={`is-12-mobile is-${columnType}-tablet column`}>
                        <LocationWithMap location={location} styles={styles} apiKey={apiKey} locale={locale} />
                    </div>
                ))}
            </div>
        </div>
    </section>)
}


// WEBPACK FOOTER //
// ./src/components/LocationsGrid.js